import React from 'react';
import { ContentArea } from '@styles/common';
import { useMenuOptions } from '@data/menu.options.data';
import { HomeIcon, HomeList, HomeListItem, HomeListItemIcon, HomeListItemText, HomeListLink } from '@screens/home/home.styles';

const Home = () => {
  const menuOptions = useMenuOptions();

  return (
    <ContentArea>
      <HomeList>
        {menuOptions.map((o) => (
          <HomeListItem key={o.id} button>
            <HomeListLink to={o.url}>
              <HomeListItemIcon>
                <HomeIcon>{o.icon}</HomeIcon>
              </HomeListItemIcon>
              <HomeListItemText primary={o.title} secondary={o.description} />
            </HomeListLink>
          </HomeListItem>
        ))}
      </HomeList>
    </ContentArea>
  );
};

export default Home;
